import React, { Component } from 'react'
import {
  Layout, Menu
} from 'antd';
import {
  Redirect,
  Link,
  withRouter
} from "react-router-dom";
import {
  DashboardOutlined,
  UserOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as Service from '../core/Service';
import { ActionCreators } from '../redux/actions';

const { Sider } = Layout;
const { SubMenu } = Menu;

let dataList = [
  {
    title: '交通消息列表',
    key: 'trafficnews_list',
    path: '/trafficnews_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '車輛列表',
    key: 'vehicle_list',
    path: '/vehicle_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '司機列表',
    key: 'driver_list',
    path: '/driver_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '司機儲值紀錄',
    key: 'driver_store_value_list',
    path: '/driver_store_value_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '訂單列表',
    key: 'order_list',
    path: '/order_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '訂單報告',
    key: 'order_list_sort_by_driver',
    path: '/order_list_sort_by_driver',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '廣告列表',
    key: 'ad_list',
    path: '/ad_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '意見回饋列表',
    key: 'feedback_list',
    path: '/feedback_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '顧客隱私權政策',
    key: 'user_tnc_list',
    path: '/user_tnc_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '司機隱私權政策',
    key: 'driver_tnc_list',
    path: '/driver_tnc_list',
    icon: <UserOutlined />,
    display: 'block'
  },
  {
    title: '管理員列表',
    key: 'admin_list',
    path: '/admin_list',
    icon: <UserOutlined />,
    display: 'block'
  }
]

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      logout: false,
    };
  }

  async toggle() {
    let { collapsed } = this.state
    this.setState({ collapsed: !collapsed });
  }

  async logout() {
    let props = this.props;
    await Service.logout();
    props.setAdmin({});
    props.setAuth(false);
    props.history.push('/login');
  }

  renderMenuItem() {
    return dataList.map((pathData, i) => {
      if (pathData.submenu) {
        return (
          <SubMenu
            key={pathData.key}
            icon={pathData.icon}
            title={pathData.title}
          >
            {pathData.submenu.map((subPathData, i) => {
              return (
                <Menu.Item key={subPathData.key}>
                  <Link to={subPathData.path}>
                    {subPathData.icon}
                    {subPathData.title}
                  </Link>
                </Menu.Item>
              )
            })}
          </SubMenu>
        )
      }
      // console.log('pathData.key>>>>', pathData.key)
      return (
        <Menu.Item
          key={pathData.key}
          onClick={this.handleClick}
          className={
            pathData.className ? pathData.className.join(' ') : ''
          }
        >
          <Link to={pathData.path}>
            {pathData.icon}
            <span>{pathData.title}</span>
          </Link>
        </Menu.Item>
      )
    })
  }

  render() {
    let { defaultSelectedKeys } = this.props;
    return (
      <Sider
        breakpoint="sm"
        collapsedWidth="0"
        collapsible 
        width={250}
        style={{
          height: '100%', opacity: 1, position: 'relative', backgroundColor: 'white'
        }}
      >
        <Menu
          mode="inline"
          defaultSelectedKeys={[defaultSelectedKeys]}
          defaultOpenKeys={['1']}
          style={{ paddingBottom: '50px', paddingTop: '20px' }}
        >
          {this.renderMenuItem()}
        </Menu>
        <Menu mode="inline" style={{ opacity: 1, position: 'relative' }}>
          {/* <Divider /> */}
          <Menu.Item key="99" onClick={() => { this.logout(); }}>
            <span>登出</span>
          </Menu.Item>
        </Menu>

        {
          this.state.logout === true
            ? <Redirect to="/login" />
            : null
        }
      </Sider>
    )
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Sidebar));
